
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

let formatMessageCallBack = undefined;
let formatDateCallBack = undefined;

export const formatMessage = (...data) => formatMessageCallBack && formatMessageCallBack(...data);
export const formatDate = (...data) => formatDateCallBack && formatDateCallBack(...data);


export default function useCommonIntl() {
    let intl = useIntl();

    useEffect(() => {
        
        formatMessageCallBack = (...data)=> intl.formatMessage(...data);
        formatDateCallBack = (...data)=> intl.formatDate(...data);

        return () => {
            formatMessageCallBack = undefined;
            formatDateCallBack = undefined;
            intl = undefined;
        }
    }, [])
}